import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { environment } from '~env/environment';

@Component({
  selector: 'app-account-flyout-context',
  templateUrl: './account-flyout-context.component.html',
  styleUrls: ['./account-flyout-context.component.scss']
})
export class AccountFlyoutContextComponent implements OnInit {
  @Output() accountFlyoutClicked = new EventEmitter();
  avatarIcon = `${environment.cdnBaseUrl()}/images/metrox/icon_avatar.svg`;
  constructor() { }

  ngOnInit(): void {
  }

  navigateToIdam(): void{
    this.accountFlyoutClicked.emit();
  }
}
